
import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {IFormValues} from '@/interfaces/form';
import {dispatchGetForm, dispatchGetFormValuesByID} from '@/store/main/actions';
import {commitAddNotification} from '@/store/main/mutations';
import {readForm, readFormValues, readUserProfile} from '@/store/main/getters';
import VueQrcode from 'vue-qrcode';

import VueHtml2pdf from 'vue-html2pdf';
import {IPrinterLog} from '@/interfaces/printer-logs';
import DisplayValue from '@/components/DisplayValue.vue';

import {apiUrl} from '@/env';

@Component({
  components: {DisplayValue, VueHtml2pdf, VueQrcode},
})
export default class Preview extends Vue {
  private localFormValues: IFormValues = {} as IFormValues;
  private formValueID: number = 0;
  private formID: number = 0;
  private progress: number = 0;
  private pdfDownloaded: boolean = false;

  private printInfos!: IPrinterLog;

  public async mounted() {
    this.formValueID = this.$router.currentRoute.params.id as unknown as number;
    this.printInfos  = {
      created_by_user: this.currentUser,
      created_by: this.currentUser?.id,
      full_url: apiUrl,
      document_id: this.formValueID,
      authorization_code: '',
      created_at: this.currentTimestamp,
    } as IPrinterLog;
    await this.loadMountSettings();
  }

  public async downloadPdf() {
    // @ts-ignore
    this.$refs.html2Pdf.generatePdf();
  }

  public startPagination() {
    console.log(`PDF has started pagination`);
  }

  public hasPaginated() {
    console.log(`PDF has been paginated`);
  }

  public async beforeDownload({html2pdf, options, pdfContent}) {
    console.log(`On Before PDF Generation`);
    await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.setFontSize(10);
        pdf.setTextColor(150);
        pdf.text('Página ' + i + ' de ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.88),
            (pdf.internal.pageSize.getHeight() - 0.3));
      }
    }).save();
  }

  public hasDownloaded(blobPdf) {
    console.log(`PDF has downloaded yehey`);
    this.pdfDownloaded = true;
  }

  public onProgress(progress) {
    this.progress = progress;
    console.log(`PDF generation progress: ${progress}%`);
  }


  private getItemText(key) {
    try {
      const fValues = this.formValues?.form_values;
      const controls = this.form?.form_setting?.form_data?.controls;
      const control = controls?.[key];
      const value = fValues?.[control.name ? control.name : control.uniqueId];

      if (this.isEmptyValue(value)) {
        return null;
      } else if (control?.type === 'radio') {
        return value;
      } else if (control?.type === 'checkbox') {
        return value;
      } else if (control?.type === 'fileUploadControl') {
        return null;
      } else if (control?.type === 'datePickerControl') {
        if (value.length !== 10) {
          return null;
        }
        if (value.includes('/')) {
          return value;
        }

        const [year, month, day] = value.split('-');
        return `${day}/${month}/${year}`;
      }

      return value;

    } catch (e) {
      console.error(e);
      return null;
    }
  }

  private isEmptyValue(value) {
    return value === null || value === undefined || value === '' || (Array.isArray(value) && value.length === 0);
  }

  private isEmptyBlockControl(control) {
    const values = [control?.type, control?.label, control?.name, control?.uniqueId]
        .filter(Boolean)
        .map((value) => String(value).toLowerCase().replace(/[\s_-]/g, ''));
    return values.includes('emptyblock') || values.includes('emptyblockcontrol');
  }

  private get parsedDate() {
    if (!this.printInfos.created_at) {
      return '-----';
    }

    const date = new Date(this.printInfos.created_at * 1000);

    return `${date.getDate()}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}
     ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;

  }

  private get currentTimestamp() {
    return Math.floor(Date.now() / 1000);
  }

  private get currentUser() {
    return readUserProfile(this.$store);
  }

  private get formValues() {
    return readFormValues(this.$store)(+this.formValueID);
  }

  private get form() {
    return readForm(this.$store)(+this.formID);
  }

  private get formData() {
    return this.form?.form_setting?.form_data;
  }

  private async loadMountSettings() {
    if (!this.formValues) {
      await dispatchGetFormValuesByID(this.$store, this.formValueID);
    }

    this.formID = this.formValues?.form_id as unknown as number;

    if (!this.form) {
      await dispatchGetForm(this.$store, this.formID);
    }


    // const cForm = this.form;
    // if (cForm?.id) {
    //   await Promise.all([
    //     await new Promise((resolve) => setTimeout(() => resolve(), 100)),
    //     this.localFormValues = {...this.formValues} as IFormValues,
    //   ]);
    // } else {
    //   commitAddNotification(this.$store, {
    //     content: 'Ocorreu um erro ao carregar as configurações do formulário. Tente novamente.',
    //     color: 'warning',
    //   });
    // }
  }

  private printPage() {
    // @ts-ignore
  }

}
